import React from 'react';
import { Row, Col, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
//redux
import { userSelector } from 'slices/user';
import { addItem } from 'slices/cart';
// icons
import { AiFillStar } from 'react-icons/ai';
import { FaTrophy } from 'react-icons/fa';
// api
import { addItemCart } from 'api/ecommerce';
// helpers
import { capitalizeText, detailTypeProductRedirect } from 'helpers';
import { formatCurrency } from 'utils/currencyFormatter';
//preview para libros sin portada
import preview from 'assets/img/preview.jpg';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import CoverImg from 'components/coverImage/CoverImage';
import Authors from 'components/authors';
import Button from 'components/userzone/buttons/ButtonCustom';

const Item = (props) => {
  const { t } = useTranslation(['home']);
  const { data } = props;
  const dispatch = useDispatch();
  const { isLogged } = useSelector(userSelector);
  const [loading, setLoading] = React.useState(false);
  const { assignedLibrary} = useAssignedLibrary();


  const addProductToCart = async (data) => {
    if (isLogged) {
      setLoading(true);
      const payload = { item: data?.id, quantity: 1 };
      const { status } = await addItemCart(payload);
      if (status === 201) {
        dispatch(addItem(data));
      } else {
        console.log('error');
      }
    } else {
      dispatch(addItem(data));
    }
    setLoading(false);
  };

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  const tooltip = (
    <Tooltip id="tooltip">
      <h5 className="m-0 text-tooltip">{t('seeProduct')}</h5>
    </Tooltip>
  );

  const evaluateTitle = data?.titulo || data?.title

  return (
    <OverlayTrigger placement="bottom" overlay={tooltip}>
      <div className="store-item position-relative">
        {props.isAward && (
          <p className="prizeName" title={props.prize.prize} >
            {props.prize.prize}
          </p>
        )}
        <div className="store-cover">
          {props.isAward && (
            <div className="trophyDiv">
              <FaTrophy />
            </div>
          )}
          {props.recommended && (
            <div className="recommendedDiv">
              <AiFillStar />
            </div>
          )}
          <div
            className={'img-container' + (props.isReview ? ' img-review' : '')}
            style={{ cursor: props.isReview ? 'default' : 'pointer' }}
          >
            <div className="overlay"></div>
            <Link to={detailTypeProductRedirect(props.data, assignedLibrary)} onClick={goUp}>
              <CoverImg src={data?.get_url || data?.image || data?.cover || preview} className="cursor-default" />
            </Link>
          </div>
        </div>
        <Row className="img-caption" style={{ marginBottom: props.isAward ? '0px' : '' }}>
          <Col xs={12}>
            {!props.isReview ? (
              <Link className="store-item__link" to={detailTypeProductRedirect(props.data, assignedLibrary)}>
                <h5 className="title limit-long" title={evaluateTitle}>
                  {capitalizeText(evaluateTitle)}
                </h5>
              </Link>
            ) : (
              <h5 className="title limit-long" title={evaluateTitle}>
                {capitalizeText(evaluateTitle)}
              </h5>
            )}
          </Col>
          <Col xs={12} className="container-authors" >
            {data?.authors && <Authors elements={data?.authors} />}
          </Col>
        </Row>
        {props.isAward ? (
          <p className="mb-3 black-color">
            {props.editorial}
          </p>
        ) : props.isReview ? (
          <Link
            className="blue text-center  style-link"
            to={`/${assignedLibrary}/pequenas-resenas/?small_reviews_id=${props.reviewId}`}
          >
            {t('watchMore')}
          </Link>
        ) : (
          <p className="store-item-price mb-1">{formatCurrency(props.data?.price)}</p>
        )}

        {!props.isReview && (
          <div className="text-center">
            <Button
              variant="outline-dark"
              size="sm"
              block="true"
              className={`${props?.childList ? 'goldenBtn' : ''} width-btn-add-cart`}
              onClick={() => addProductToCart(data)}
              disabled={!props.data?.has_stock}
              loading={loading}

            >
              {props.data?.has_stock ? t('anadirCesta') : t('outOfStock')}
            </Button>
          </div>
        )}
      </div>
    </OverlayTrigger>

  );
};

export default Item;
